import { GetterTree } from 'vuex'
import { IRootState, IAuthState } from '@/@types'

const getters: GetterTree<IAuthState, IRootState> = {
  userProfile: state => {
    return state?.userProfile ?? null
  },
  isAuthenticated: state => {
    return state?.isAuthenticated ?? false
  },
}

export default getters
